import { render } from "./tabTemplate.vue?vue&type=template&id=5045cc5c&scoped=true&ts=true"
import script from "./tabTemplate.vue?vue&type=script&lang=ts"
export * from "./tabTemplate.vue?vue&type=script&lang=ts"

import "./tabTemplate.vue?vue&type=style&index=0&id=5045cc5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5045cc5c"]])

export default __exports__